import {
  ConeGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry,
  TorusGeometry
} from 'three';

/** Lulu mesh — pix orb + whimsical hat cue. */
export function createLuluMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0xa78bfa : 0xfbbf24;
  const bodyMat = new MeshStandardMaterial({ color: 0x7c3aed, roughness: 0.5 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.35 });

  const body = new Mesh(new ConeGeometry(0.55, 1.8, 10), bodyMat);
  body.position.y = 1.1;
  group.add(body);

  const head = new Mesh(new SphereGeometry(0.42, 12, 12), trimMat);
  head.position.y = 2.25;
  group.add(head);

  const hat = new Mesh(new ConeGeometry(0.5, 0.9, 8), bodyMat);
  hat.position.y = 2.9;
  group.add(hat);

  const pix = new Mesh(new SphereGeometry(0.18, 10, 10), trimMat);
  pix.position.set(0.85, 2.1, 0.2);
  group.add(pix);

  const ring = new Mesh(new TorusGeometry(0.28, 0.04, 8, 16), trimMat);
  ring.rotation.x = Math.PI / 2;
  ring.position.set(0.85, 2.1, 0.2);
  group.add(ring);

  return group;
}
